import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import './ReferralFormTab.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

function ReferralFormTab() {
    const referral = useSelector((store) => store.referralReducer);
    const partners = useSelector((store) => store.partnerReducer);
    const [referralCode, setReferralCode] = useState('');
    const code = referralCode.toUpperCase();
    const history = useHistory();
    const dispatch = useDispatch();
    const toReferral = () => {
        const code = referralCode.toUpperCase();

        const payload = {
            code: code,
            history: history,
        }

        console.log('Referral code entered:', code);

        if (!code) {
            Swal.fire({
                title: `Please enter a valid referral partner code!`,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK',
            });
        } else {
            dispatch({ type: 'FETCH_PARTNER', payload: payload });
        }
    }

    return (

        <>
        <Nav />
            <div id='ref-tab' className="center mt-5">
                <h3>Referral Form Code Login</h3>
                <p>Enter assigned code to access the referral form. Complete all questions on the referral form
                in order to refer a client. Once the form is completed, an email will be sent to your agency
                to confirm that the form has been completed and to instruct the referral staff member
                on the next steps to take.
                </p>
                <p><label htmlFor='setReferralCode'>Referral Code:</label>
                    <input value={referralCode} onChange={(e) => { setReferralCode(e.target.value) }} /></p>
                <p><Button value={referralCode} onClick={toReferral}>Proceed to Referral Page</Button></p>
            </div>
            <Footer />
        </>
    )

}


export default ReferralFormTab



